<template>
 <div class="title-bar clearfix"> 
 <div slot="header" class="clearfix">
   <div class="module pull-left">
        {{ $t("EANCodeManagement") }}
      </div>
      
      <div class="btn-group pull-right">
       <FileImporter apiurl="api/eancodes/import"  v-if="false" style="float:left;margin-right:16px"></FileImporter>
        <el-button   :plain="true" size="mini" v-if="canEdit" @click="addEAN">{{ $t("add") }}
          <i class="fa fa-plus"></i>
        </el-button>
        
        <el-button  :plain="true" size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button   :plain="true" size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>
        
      </div>
    </div>
  <div class="data-list"
      v-loading="loading"
      element-loading-text="Loading"
    >
  <el-table  class="customer-table" border stripe   :data="EANData" size="mini"> 
     <el-table-column  v-if="canEdit" label="操作" align="center" width="180" :resizable="true" >
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">{{$t("edit")}}</el-button>
         
          <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">{{$t("delete")}}</el-button>
        </template>
      </el-table-column>
     <el-table-column
      prop="EANCode"
      header-align="center"
      align="center"
      :label="this.$t('EANCode')"
     >
    </el-table-column>
     
      <el-table-column
      prop="ProductSerials"
      :label="this.$t('ProductSerials')"
      header-align="center"
      align="center"
    >
    </el-table-column>

    <el-table-column
      prop="ProductLongCode"
     :label="this.$t('ProductLongCode')"
      header-align="center"
      align="center"
     >
    </el-table-column>

    <el-table-column
      prop="ProductShortCode"
      :label="this.$t('ProductShortCode')"
      header-align="center"
      align="center"
     >
    </el-table-column>

     <el-table-column
      prop="AmountPerPackage"
      :label="this.$t('AmountPerPackage')"
      header-align="center"
      align="center"
    >
    </el-table-column>

    <el-table-column
      prop="SuggestedRetailPrice"
      :label="this.$t('SuggestedRetailPrice')"
      header-align="center"
      align="center"
      :formatter="priceFormatter"
    >
    </el-table-column>
    
  </el-table>
   <el-row style="margin-top:10px;">
      <el-pagination style="float:right" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
        :page-sizes="[15,30,50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </el-row>
  
   <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible" width="45%"  > 
      
     
         <el-form class="search-form"
          ref="searchEANCode"
        :model="filter" 
        :inline="true"
        size="small" 
        label-width="100px"
        :rules="rules">  
        
            <el-form-item :label="this.$t('EANCode')" size="small" :label-width="searchDialogLabelWidth" prop="EANCode">
              
              <el-input v-model="filter.EANCode" auto-complete="off"></el-input>
             
            </el-form-item>
       
            <el-form-item :label="this.$t('ProductLongCode')" size="small" :label-width="searchDialogLabelWidth" prop="ProductLongCode">
              
              <el-input v-model="filter.ProductLongCode" auto-complete="off"></el-input>
             
            </el-form-item>
         
            <el-form-item :label="this.$t('ProductShortCode')" size="small" :label-width="searchDialogLabelWidth" prop="ProductShortCode">
              
              <el-input v-model="filter.ProductShortCode" auto-complete="off"></el-input>
            
            </el-form-item>
         
            <el-form-item :label="this.$t('AmountPerPackage')" size="small" :label-width="searchDialogLabelWidth" prop="AmountPerPackage">
              
              <el-input v-model="filter.AmountPerPackage" auto-complete="off"></el-input>
             
            </el-form-item>

            <el-form-item :label="this.$t('ProductSerials')" size="small" :label-width="searchDialogLabelWidth">
              <el-input v-model="filter.ProductSerials" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item :label="this.$t('SuggestedRetailPrice')" size="small" :label-width="searchDialogLabelWidth" prop="SuggestedRetailPrice">
              
              <el-input v-model="filter.SuggestedRetailPrice" auto-complete="off"></el-input>
             
            </el-form-item>
        
           
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="searchDialogVisible = false" plain size="mini">{{this.$t('cancel')}}</el-button>
          <el-button @click="resetFilter" :plain="true" size="mini">{{$t('reset')}}</el-button>
        <el-button type="primary" @click="search('searchEANCode')" plain size="mini">{{this.$t('confirm')}}</el-button>
      </div>
    </el-dialog>

   </div>
  </div>
 
</template>

<script>
import OperationHeader from "@/components/shared/OperationHeader";
import qs from "qs";
import FileImporter from "@/components/shared/FileImporter";
import _ from "lodash";
import { mapGetters } from "vuex";
import roleTypes from "../../../models/roleTypes";
import searchTypes from "../../../models/searchTypes";
import searchHistoryService from "../../../services/searchHistoryService";
export default {
  name: "EANCode",
  components: { OperationHeader, FileImporter },
  data() {
    return {
      loading: true,
      filter: {
        EANCode: "",
        ProductLongCode: "",
        ProductShortCode: "",
        AmountPerPackage: "",
        ProductSerials: "",
        SuggestedRetailPrice: ""
      },
      rules: {
        EANCode: [
          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9]/g, "");
              if (raw.length > format.length) {
                callback(new Error("EAN码只能为阿拉伯数字"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        ProductLongCode: [
          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9-]/g, "");
              if (raw.length > format.length) {
                callback(new Error("只能包含数字或‘-’"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        ProductShortCode: [
          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9]/g, "");
              if (raw.length > format.length) {
                callback(new Error("短号只能为阿拉伯数字"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],

        AmountPerPackage: [
          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9]/g, "");
              if (raw.length > format.length) {
                callback(new Error("请输入一个整数"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      searchDialogLabelWidth: "120px",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      searchDialogVisible: false,
      EANData: [],
      filterOptions: []
    };
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
    canEdit() {
      return (
        this.roles.includes(roleTypes.Administrator) ||
        this.permissions.find(
          p =>
            p.toLowerCase() === "ean.edit" || p.toLowerCase() === "ean.insert"
        )
      );
    }
  },
  created() {
    this.initializeFilter();
    this.obtainTableDataAccordingToConditions();
  },
  methods: {
    priceFormatter(row, column) {

     return Number(row.SuggestedRetailPrice).toFixed(2)
    },
    addEAN() {
      this.$router.push("addEAN");
    },
    handleEdit(index, row) {
      this.$router.push({ name: "EditEAN", params: { EANId: row.Id } });
    },
    handleDelete(index, row) {
      this.$confirm("同时删除对应返现信息，确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.deleteData(row.Id);
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handlekeyup(event) {
      var father = event.currentTarget;
      var input = father.getElementsByTagName("input")[0];
      input.value = input.value.replace(/[^0-9]/g, "");
    },

    handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },
    resetFilter() {
      this.filter = {
        EANCode: "",
        ProductLongCode: "",
        ProductShortCode: "",
        AmountPerPackage: "",
        ProductSerials: "",
        SuggestedRetailPrice:""
      };
      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.EAN_HISTORY);
    },
    obtainTableDataAccordingToConditions() {
      this.loading = true;
      this.$axios
        .get("api/eancodes/getean", {
          params: {
            filter: this.filtergenerator(),
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        })
        .then(response => {
          this.EANData = response.data.Data;
          this.loading = false;
          this.totalCount = response.data.TotalCount;
        });
    },
    deleteData(rowId) {
      this.$axios
        .get("api/eancodes/deleteEANCode", {
          params: {
            Id: rowId
          }
        })
        .then(response => {
          this.$message({
            type: "success",

            message: "删除成功"
          });
          this.obtainTableDataAccordingToConditions();
        });
    },

    refresh() {
      this.pageIndex = 1;
      this.resetFilter();
      this.obtainTableDataAccordingToConditions();
    },

    initializeFilter() {
      let his = searchHistoryService.getHistory(searchTypes.EAN_HISTORY);
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    setFilterOptions() {
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (typeof val === "number" || val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
    },
    search(searchEANCode) {
      this.$refs[searchEANCode].validate(valid => {
        if (valid) {
          this.searchDialogVisible = false;

          this.pageIndex = 1;
          this.setFilterOptions();
          searchHistoryService.setHistory(
            searchTypes.EAN_HISTORY,
            this.filterOptions
          );
          this.obtainTableDataAccordingToConditions();
        } else {
          this.$message({
            message: this.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },

    filtergenerator() {
      var filterOptions = [];
      if (this.filter.EANCode !== null && this.filter.EANCode.trim() !== "") {
        var filterOption = {
          name: "EANCode",
          value: this.filter.EANCode
        };

        filterOptions.push(filterOption);
      }
      if (
        this.filter.ProductSerials !== null &&
        this.filter.ProductSerials !== ""
      ) {
        var filterOption = {
          name: "ProductSerials",
          value: this.filter.ProductSerials
        };

        filterOptions.push(filterOption);
      }

      if (
        this.filter.ProductLongCode !== null &&
        this.filter.ProductLongCode.trim() !== ""
      ) {
        var filterOption = {
          name: "ProductLongCode",
          value: this.filter.ProductLongCode
        };

        filterOptions.push(filterOption);
      }

      if (
        this.filter.ProductShortCode !== null &&
        this.filter.ProductShortCode.trim() !== ""
      ) {
        var filterOption = {
          name: "ProductShortCode",
          value: this.filter.ProductShortCode
        };

        filterOptions.push(filterOption);
      }

      if (
        this.filter.AmountPerPackage !== null &&
        this.filter.AmountPerPackage.trim() !== ""
      ) {
        var filterOption = {
          name: "AmountPerPackage",
          value: this.filter.AmountPerPackage
        };
        filterOptions.push(filterOption);
      }

            if (
        this.filter.SuggestedRetailPrice !== null &&
        this.filter.SuggestedRetailPrice.trim() !== ""
      ) {
        var filterOption = {
          name: "SuggestedRetailPrice",
          value: this.filter.SuggestedRetailPrice
        };
        filterOptions.push(filterOption);
      }

      return JSON.stringify(filterOptions);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/application/EANCode/EANCode.vue